import { render, staticRenderFns } from "./HeaderAwaitingBox.vue?vue&type=template&id=0c044286"
import script from "./HeaderAwaitingBox.vue?vue&type=script&lang=js"
export * from "./HeaderAwaitingBox.vue?vue&type=script&lang=js"
import style0 from "./HeaderAwaitingBox.vue?vue&type=style&index=0&id=0c044286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports